<div class="row">
    <div class="col-lg-12 p-0">
           <div class="top_header">	
                   <span>Inland Marine Coverage You Can Count On</span>
           </div>
           <div class="top_header_notification">
                   <span><img src="./xps/asset/img/notification_icon.png" width="25px"> &nbsp;Coronavirus (COVID-19) <a href="#">Learn More</a> about the steps we're taking </span>
           </div>
    </div>
   </div>

   <div class="row">
    <div class="col-lg-5 p-lg-0">
        <div class="berkely_logo_sec text-center mt-lg-5">
            <img src="./xps/asset/img/BFM_logo.jpg" >
            <br/>				
                <a href="#" class="green_btn">Buy Online <i class="fa fa-chevron-right ml-2" aria-hidden="true"></i> </a>
                <a href="#" class="blue_btn">See How it Works <i class="fa fa-play-circle-o ml-2" aria-hidden="true"></i></a>
        </div>
    </div>
    <div class="col-lg-7 p-lg-0">
        <div class="slider_cls">
            <!-- <img src="slider_img.jpg"> -->
                    <div id="demo" class="carousel slide" data-ride="carousel">
                      <ul class="carousel-indicators">
                        <li data-target="#demo" data-slide-to="0" class="active"></li>
                        <li data-target="#demo" data-slide-to="1"></li>
                        <li data-target="#demo" data-slide-to="2"></li>
                      </ul>
                      <div class="carousel-inner">
                        <div class="carousel-item active">
                          <img src="./xps/asset/img/truck_bg.jpeg" alt="Los Angeles" width="1100" height="500">
                          <div class="carousel-caption">
                            <h3>Transportation</h3>
                            <p>Coverage designed for what is on the inside</p>
                          </div>   
                        </div>
                        <div class="carousel-item">
                          <img src="./xps/asset/img/truck_bg.jpeg" alt="Chicago" width="1100" height="500">
                          <div class="carousel-caption">
                            <h3>Transportation 1</h3>
                            <p>Coverage designed for what is on the inside</p>
                          </div>   
                        </div>
                        <div class="carousel-item">
                          <img src="./xps/asset/img/truck_bg.jpeg" alt="New York" width="1100" height="500">
                          <div class="carousel-caption">
                            <h3>Transportation 2</h3>
                            <p>Coverage designed for what is on the inside</p>
                          </div>   
                        </div>
                      </div>
                      <a class="carousel-control-prev" href="#demo" data-slide="prev">
                        <span class="carousel-control-prev-icon"></span>
                      </a>
                      <a class="carousel-control-next" href="#demo" data-slide="next">
                        <span class="carousel-control-next-icon"></span>
                      </a>
             </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-lg-12 p-0">
        <nav class="navbar navbar-expand-sm bg-dark navbar-dark">
          <a class="navbar-brand d-lg-none d-md-none" href="#">Menu</a>
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="collapsibleNavbar">
            <ul class="navbar-nav">
             
             <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Products
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item" href="#">Products 1</a>
                  <a class="dropdown-item" href="#">Products 2</a>					 
                </div>
              </li>
              
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  For Our Customers
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item" href="#">Customers 1</a>
                  <a class="dropdown-item" href="#">Customers 2</a>					 
                </div>
              </li>
              
               <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  News
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item" href="#">News 1</a>
                  <a class="dropdown-item" href="#">News 2</a>					 
                </div>
              </li>
              
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  About Us
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item" href="#">About 1</a>
                  <a class="dropdown-item" href="#">About 2</a>					 
                </div>
              </li>
              
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                 Carreers
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item" href="#">Carreers 1</a>
                  <a class="dropdown-item" href="#">Carreers 2</a>					 
                </div>
              </li>
              
               <li class="nav-item">
                    <a class="nav-link"  href="#">Contact Us</a>
               </li>
               
               <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                 Agent Portal
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item" href="#">Agent 1</a>
                  <a class="dropdown-item" href="#">Agent 2</a>					 
                </div>
              </li>
              
            </ul>
          </div>  
        </nav>
    </div>
</div>
<div class="row pt-3 pb-3 mt-4 mb-4">		
    <div class="col-md-12 text-center">
        <span class="content_hedng">
            Bulider's Risk online quotes. <br/> The right answer to cover your construction projects.
        </span>
    </div>
</div>

<div class="row">
<div class="col-md-8 mx-auto">
    <div class="row ">
        <div class="col-lg-3 col-md-6 mb-3 border_right_cls">
            <div class="number_style">
                <span class="inside_number">4</span>
            </div>
            <div class="number_title">
                4 <br/> Simple <br/> Questions
            </div>
        </div>
        
        <div class="col-lg-3 col-md-6 mb-3 border_right_cls">
            <div class="number_style">
                <span class="inside_number">3</span>
            </div>
            <div class="number_title">
                3 <br/> Competitive <br/> Quotes
            </div>
        </div>
        
        <div class="col-lg-3 col-md-6 mb-3 border_right_cls">
            <div class="number_style">
                <span class="inside_number">2</span>
            </div>
            <div class="number_title">
                2 <br/> Minutes <br/> or Less
            </div>
        </div>
        
        <div class="col-lg-3 col-md-6 mb-3">
            <div class="number_style">
                <span class="inside_number">1</span>
            </div>
            <div class="number_title">
                1 <br/> Easy Click <br/> for Details
            </div>
        </div>
        
    </div>
</div>
</div>

<div class="row">
    <div class="col-md-8 mx-auto">
        <div class="row button_cls text-center mb-5">					
                <div class="col-lg-6">
                    <a href="#" class="green_btn">Buy Online <i class="fa fa-chevron-right ml-2" aria-hidden="true"></i> </a>
                </div>
                <div class="col-lg-6">
                    <a href="#" class="blue_btn">Service Center <i class="fa fa-chevron-right ml-2" aria-hidden="true"></i></a>
                </div>					
        </div>
        
        <div class="row mt-3 mb-3 pt-3 pb-5">
            <div class="col-md-12 text-center">
                <img src="./xps/asset/img/e-pay.jpg">
            </div>
        </div>
        
    </div>
</div>


<div class="row">
<div class="col-md-12 p-0">
    <div class="home_footer text-center">
    <p>Berkley National Insurance Company &#8226; Berkley Regional Insurance Company &#8226; StarNet Insurance Company &#8226; Berkley Specialty Insurance Company <br/> 
    &copy;2019 Berkley Fire and Marine Underwriters All Rights Reserved. | Online Privacy Policy | New York Disclosure | Terms of Use | Legal and Licensing | Sitemap | Version: 1.0.0.0
</div>
</div>
</div> 
  





